import { useFacebookAdsSettings } from 'app/components/facebook-ads-settings/useFacebookAdsSettings'
import { FacebookAdsSettingsComponent } from 'app/components/facebook-ads-settings/FacebookAdsSettingsComponent'

export default function FacebookAds() {
  const props = useFacebookAdsSettings()
  return <FacebookAdsSettingsComponent {...props} />
}
